export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2359_28081)">
                <path
                    d="M4.75391 22.3674C4.75391 17.1004 9.02372 12.8306 14.2907 12.8306C19.5576 12.8306 23.8275 17.1004 23.8275 22.3674"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.84375 22.3674C4.84375 17.1004 9.11356 12.8306 14.3805 12.8306C19.6475 12.8306 23.9173 17.1004 23.9173 22.3674"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.375 21.875C12.375 20.6325 13.3824 19.625 14.6251 19.625C15.8676 19.625 16.875 20.6325 16.875 21.875"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.4025 24.5015H2.25L3.52892 22.7764H24.4841L26.4025 24.5015Z"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.9877 24.5308L22.2441 24.7466L22.6468 25.386L21.8841 25.5255L22.2152 26.2023L21.4414 26.2642L21.6977 26.9706L20.9211 26.9544L21.0988 27.6826L20.3286 27.5883L20.4264 28.3304L19.6706 28.1592L19.6874 28.9069L18.9542 28.6605L18.8899 29.406L18.1874 29.087L18.0427 29.8219L17.3789 29.4339L17.1549 30.1503L16.5369 29.6975L16.2359 30.3872L15.6706 29.8748L15.2968 30.5311L14.7898 29.9641L14.3477 30.579L13.9049 29.9641L13.398 30.5311L13.0242 29.8748L12.4587 30.3872L12.1585 29.6975L11.5397 30.1503L11.3164 29.4339L10.6527 29.8219L10.5074 29.087L9.80486 29.406L9.74062 28.6605L9.0074 28.9069L9.02477 28.1592L8.2684 28.3304L8.36622 27.5883L7.59596 27.6826L7.77413 26.9544L6.99751 26.9706L7.25391 26.2642L6.4796 26.2023L6.81066 25.5255L6.04793 25.386L6.45066 24.7466L5.70703 24.5308"
                    stroke="black"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                />
                <path d="M23.625 19.625H29.25" stroke="black" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.625 21.875H29.25" stroke="black" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.5135 22.8028H30.443C29.784 22.8028 29.25 22.0017 29.25 21.0139V13.3597C29.25 12.3714 29.784 11.5703 30.443 11.5703H31.5135C32.1721 11.5703 32.7061 12.3714 32.7061 13.3597V21.0139C32.7061 22.0017 32.1721 22.8028 31.5135 22.8028Z"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.2497 12.3125C26.2549 9.98855 22.3316 8.20426 18.4468 7.29146C17.741 7.12585 17.0134 7.46786 16.6812 8.11213L14.25 12.8197"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.2473 15.6874C26.7422 13.3224 23.3585 11.8435 19.9601 10.7061L18.6641 13.2982"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.75 15.125C16.8756 15.5369 17.881 16.2003 18.6971 17.0464"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2359_28081">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
